import { Select } from "@alm/flow-ds/components";
import React, { ChangeEvent, Dispatch, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Actions, SearchField, setFieldValue } from "./finderReducer";

type Props = {
	dispatch: Dispatch<Actions>;
	searchFieldOptions: SearchField[];
};

function AddSearchField({ searchFieldOptions, dispatch }: Props) {
	const { t } = useTranslation();

	const onChange = useCallback(
		(e: ChangeEvent<HTMLSelectElement>) => {
			dispatch(setFieldValue(e.currentTarget.value));
		},
		[dispatch]
	);

	return (
		<div className="form-row pt-4">
			<div className="col-12 col-md-3">
				<Select
					onChange={onChange}
					labelHidden={true}
					label={t("elements.finder.add-search-field")}
					value={undefined}>
					<option aria-hidden value={undefined}>
						{t("elements.finder.add-search-field")}
					</option>

					{searchFieldOptions.map(op => (
						<option value={op.name} key={op.name}>
							{op.label}
						</option>
					))}
				</Select>
			</div>
		</div>
	);
}

export default AddSearchField;
